import React from "react";
import { Link } from "react-router-dom";

const DetailCtaArea = () => {
  return (
    <section className="space-extra bg-secondary mt-5">
      <div className="container">
        <div className="row align-items-center justify-content-center justify-content-lg-between pl-10">
          <div className="col-lg-8 col-md-10 mb-4 mb-lg-0 text-center text-lg-start">
            <h2 className="mb-5 text-white">
              Are you interested in this property?
            </h2>
          </div>
          <div className="flex gap-5 text-center text-lg-start">
            <Link to="tel:+2348000000000" className="th-btn bg-primary mr-2">
              Call us
              <i className="fas fa-phone ms-2" />
            </Link>
            <Link to="https://wa.me/2348106092916" className="th-btn bg-success mr-2">
              Chat on WhatsApp
              <i className="fas fa-comment ms-2" />
            </Link>
            <Link to="/contact" className="th-btn style6 style-new mr-2">
              Get in touch with us
              <i className="fas fa-envelope ms-2" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DetailCtaArea;
